var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.236 8.424c.075 4.533-3.877 5.806-3.877 5.806s1.61-1.556 1.535-5.543C23.82 4.7 20.823 2.73 20.823 2.73s5.339 1.162 5.413 5.694zM8.47 29.718 3 29.981v-.499c0 .001 3.346-.336 3.346-6.204V8.28C6.346 3.31 3 2.45 3 2.45V2l5.47.262v27.456zm8.74.281c-2.38.018-6.794-.307-6.794-.307V2.3c1.092-.014 1.917-.079 2.648-.135 1.22-.095 2.179-.17 3.676.04 2.398.338 4.458 2.68 5.02 5.02.562 2.342-.037 4.57-.806 5.787-.768 1.218-2.453 2.06-2.453 2.06.001 0 2.548.862 3.448 1.611.9.75 2.64 2.79 1.966 7.23-.674 4.439-4.327 6.068-6.705 6.086zm6.32-1.012s2.594-2.21 2.48-6.691c-.115-4.482-2.48-6.588-2.48-6.588s4.878 1.198 4.934 6.536c.056 5.337-4.934 6.742-4.934 6.742zM17.677 4.901c2.116 1.463 2.666 5.74.918 8.012-1.748 2.273-6.105 1.674-6.105 1.674s-.02-9.592.411-10.004c.432-.411 2.66-1.144 4.777.319zM12.49 16.47s4.793-.187 6.43.525c1.635.712 3.708 3.133 2.697 7.042-1.012 3.908-4.083 4.02-5.694 3.958-.03 0-.058-.002-.087-.003-1.58-.06-3.076-.116-3.247-4.567-.175-4.532-.1-6.954-.1-6.954z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlk);
export default __webpack_public_path__ + "static/media/BLK.242e977d0afb9b46f65ac7db074f0965.svg";
export { ForwardRef as ReactComponent };